import React, { Component } from 'react';
import { styler, pointer, value, physics } from 'popmotion';

class Toy extends Component {
  componentDidMount() {
    this.draggbleStyler = styler(this.draggable);
    this.xy = value(
      { x: (window.innerWidth - this.draggable.offsetWidth) * 0.5, y: window.innerHeight * 0.5 },
      this.draggbleStyler.set,
    );
    this.ball = physics({
      acceleration: { x: 0, y: 2000 },
      velocity: this.xy.getVelocity(),
      from: this.xy.get(),
      friction: 0.05,
    }).start((v) => {
      this.xy.update(v);
      this.checkBounce(v);
    });
  }
  componentWillUnmount() {
    this.ball.stop();
  }
  onDrag = (e) => {
    e.preventDefault();
    if (this.ball) {
      this.ball.stop();
    }
    this.point = pointer(this.xy.get()).start(this.xy);
    window.addEventListener('mouseup', this.onDragEnd);
    window.addEventListener('touchend', this.onDragEnd);
  };
  onDragEnd = () => {
    window.removeEventListener('mouseup', this.onDragEnd);
    window.removeEventListener('touchend', this.onDragEnd);
    this.point.stop();
    this.ball = physics({
      acceleration: { x: 0, y: 2000 },
      velocity: this.xy.getVelocity(),
      from: this.xy.get(),
      friction: 0.05,
    }).start((v) => {
      this.xy.update(v);
      this.checkBounce(v);
      this.props.cb(v);
    });
  };
  checkBounce = (v) => {
    const wh = window.innerHeight;
    const ww = window.innerWidth;
    const h = ww > 768 ? wh - 200 : wh - 160;
    const w = ww - this.draggable.offsetWidth;
    let vx = this.xy.getVelocity().x;
    let vy = this.xy.getVelocity().y;
    let { x, y } = this.xy.get();
    let shouldUpdate = false;
    if (v.y > h) {
      shouldUpdate = true;
      y = h;
      if (Math.abs(vy) < 300) {
        this.ball.setAcceleration({ x: 0, y: 0 });
        vy = 0;
      } else {
        vy = -Math.abs(vy) * 0.5;
      }
    }
    if (v.x > w) {
      shouldUpdate = true;
      x = w;
      vx = -Math.abs(vx);
    } else if (v.x < 0) {
      shouldUpdate = true;
      x = 0;
      vx = Math.abs(vx);
    }
    if (shouldUpdate) {
      this.ball.set({ x, y });
      this.ball.setVelocity({ x: vx, y: vy });
    }
  };
  render() {
    return (
      <div style={{ position: 'fixed' }}>
        <div
          ref={r => (this.draggable = r)}
          // style={{ width: '100px', height: '100px' }}
          onTouchStart={this.onDrag}
          onMouseDown={this.onDrag}
        >
          <img
            style={{ width: '100px', height: '100px', borderRadius: '50%' }}
            src={this.props.src}
            alt=""
          />
        </div>
      </div>
    );
  }
}

export default Toy;



// WEBPACK FOOTER //
// ./src/Components/Toy/index.js